export default __webpack_public_path__ + "static/media/51.2bd28e65.jpeg";